import React from 'react';
import { KENTICO_TYPES } from 'common/consts/kentico';

import {
  ThreeColumnGrid,
  Banner,
  SimpleAccordion,
  Accordion,
  CardSlider,
  DownloadBar,
  TwoColumnGrid,
  ImagedSection,
  ContactForm,
  ContactFormSupport,
  HeroImage,
  ImageSlider,
  CallUs,
  HorizontallyNavigableContent,
  LinkBanner,
  ProductSlider,
  Calculator,
  ArticleSlider,
  FAQAccordion,
  TitleAndSubtitle,
  CroppedAsset,
} from 'kentico-blocks';

const productsSectionParser = (model) => {

  switch (model.system.type) {
    case KENTICO_TYPES.CROPPED_ASSET:
      return (
        <CroppedAsset
          data={model}
          key={model.system.id}
        />
      );
    case KENTICO_TYPES.THREE_COLUMN_GRID:
      return <ThreeColumnGrid data={model} key={model.system.id} />;
    case KENTICO_TYPES.BANNER:
      return <Banner data={model} key={model.system.id} />;
    case KENTICO_TYPES.SIMPLE_ACCORDION:
      return <SimpleAccordion data={model} key={model.system.id} />;
    case KENTICO_TYPES.ACCORDION:
      return <Accordion data={model} key={model.system.id} />;
    case KENTICO_TYPES.CARD_SLIDER:
      return <CardSlider data={model} key={model.system.id} />;
    case KENTICO_TYPES.DOWNLOAD_BAR:
      return <DownloadBar data={model} key={model.system.id} />;
    case KENTICO_TYPES.TWO_COLUMN_GRID:
      return <TwoColumnGrid data={model} key={model.system.id} />;
    case KENTICO_TYPES.IMAGED_SECTION:
      return <ImagedSection data={model} key={model.system.id} />;
    case KENTICO_TYPES.CONTACT_FORM:
      return <ContactForm data={model} key={model.system.id} />;
    case KENTICO_TYPES.CONTACT_FORM_SUPPORT:
      return <ContactFormSupport data={model} key={model.system.id} />;
    case KENTICO_TYPES.HERO_IMAGE:
      return <HeroImage data={model} key={model.system.id} />;
    case KENTICO_TYPES.IMAGE_SLIDER:
      return <ImageSlider data={model} key={model.system.id} />;
    case KENTICO_TYPES.CALL_US:
      return <CallUs data={model} key={model.system.id} />;
    case KENTICO_TYPES.HORIZONTALLY_NAVIGABLE_CONTENT:
      return <HorizontallyNavigableContent data={model} key={model.system.id} />;
    case KENTICO_TYPES.LINK_BANNER:
      return <LinkBanner data={model} key={model.system.id} />;
    case KENTICO_TYPES.PRODUCT_SLIDER:
      return <ProductSlider data={model} key={model.system.id} />;
    case KENTICO_TYPES.CALCULATOR:
      return <Calculator data={model} key={model.system.id} />;
    case KENTICO_TYPES.ARTICLE_SLIDER:
      return <ArticleSlider data={model} key={model.system.id} />;
    case KENTICO_TYPES.FAQ_ACCORDION:
      return <FAQAccordion data={model} key={model.system.id} />;
    case KENTICO_TYPES.TITLE_AND_SUBTITLE:
      return <TitleAndSubtitle data={model} key={model.system.id} />;
    default:
      return <span key={model.system.id} />;
  }
};

export default productsSectionParser;



// WEBPACK FOOTER //
// ./src/pages/Product/ProductsSectionParser.jsx